<template>
  <input type="hidden" :name="fieldName" v-model="fieldVal" aria-required>
  <div class="opts" :class="optClass" :id="fieldName" role="radiogroup" aria-required :aria-labelledby="`${fieldName}Title`">
    <template v-for="(opt, index) in builder[props.optionsSource]"
      v-bind:key="`${fieldName}${index}`">


      <div class="opts-subgroup" v-if="props.displayType.includes('subgroups') && opt.displaySubGroupTitle" v-html="opt.subGroup"></div>

      <!-- <div class="opts-subgroup" v-if="props.displayType.includes('subgroups') && opt.displaySubGroupTitle && opt.subGroup == 'Metro Caesarstone Benchtop Range - 20mm'" style="color:#AC0201; font-weight: 700; font-size: 80%; margin-top: 0;">SALE ON NOW - FREE Stone Upgrade from Premium Laminate (<a href="/terms-and-conditions/" target="_blank" style="color:#AC0201;">Terms & Conditions Apply</a>)</div> -->

      <button
      type="button"
      :id="`${fieldName}${index}`"
      class="opt"
      :class="[
        {
          's_active' : isSelected(builder[props.optionsSource][index]),
          'l_no-image' : !opt.image || !opt.image.length
        },
        optClass
      ]"
      @click="toggleSelect($event, index)"
      role="radio"
      :aria-checked="isSelected(builder[props.optionsSource][index])">
        <div class="opt-inner">
          <div class="opt-header">
            <div class="opt-title" v-if="!(props.displayType.includes('visual') && builder[props.optionsSource][index].id == 2643)">{{ opt.overrideTitle ?? opt.displayTitle ?? opt.title }}</div>
            <div class="opt-subtitle" v-if="!props.displayType.includes('visual') && typeof opt.subtitle !== 'undefined'">
              <span v-html="opt.subtitle"></span>
              <button class="opt-help" v-if="props.displayType.includes('delivery') && opt.description.length" @click.stop="lightboxActivate($event, index)">
                ?
              </button>
            </div>
            <button class="opt-info" v-if="props.displayType.includes('config') && ( (typeof opt.configIds !== 'undefined' && !opt.configIds.length) || typeof opt.configIds !== 'undefined' ) && opt.description" @click.stop="viewInfo($event, index)">
              <svg class="icon"><use xlink:href="#info2"></use></svg>
            </button>
            <button class="opt-help" v-if="(props.displayType.includes('combo') || props.displayType.includes('visual')) && hasLightbox(opt)" @click.stop="lightboxActivate($event, index)">
              <svg class="icon"><use xlink:href="#zoom"></use></svg>
            </button>
          </div>
          <div class="opt-tag" :class="`l_${opt.tagColour}`" v-if="props.displayType.includes('visual') && opt.tag" v-html="opt.tag"></div>
          <div class="opt-image" v-if="props.displayType.includes('combo') || props.displayType.includes('visual')">
            <div class="opt-img" :style="`background-image: url(${opt.overrideImage ?? opt.image});`"></div>
          </div>
        </div>
      </button>

      <div v-if="fieldName == 'deliveryType' && index == 0 && builder[props.optionsSource].length > 1" class="optsep">OR</div>

    </template>
  </div>

  <div class="opts-subgroup" v-if="toggledMessage.length" style="background: #000; border-radius: 10px; padding: 10px 15px; color:#fff; font-weight: 700; font-size: 75%; margin-top: 20px; display: inline-block; width: auto;"  v-html="toggledMessage"></div>

</template>

<script setup>
import { computed } from 'vue'

const props = defineProps([
  'key',
  'fieldName',
  'displayType',
  'optionsSource',
  'selected',
  'scope'
])

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

import { useLightboxStore } from "@/stores/lightbox";
const lightbox = useLightboxStore();

const emit = defineEmits(['selectOption'])

function toggleSelect(e, optIndex) {
  emit('selectOption', props.fieldName, builder[props.optionsSource][optIndex]);
  e.preventDefault();
  return false;
}

function viewInfo(e, optIndex) {
  emit('viewInfo', builder[props.optionsSource][optIndex]);
  e.preventDefault();
  return false;
}

function lightboxActivate(e, optIndex) {
  let description = builder[props.optionsSource][optIndex].description;
  if (props.fieldName == 'configId') description = '';
  let gallery = [];
  if (!_.isUndefined(builder[props.optionsSource][optIndex].overrideGallery) && builder[props.optionsSource][optIndex].overrideGallery && builder[props.optionsSource][optIndex].overrideGallery.length) gallery = JSON.parse(builder[props.optionsSource][optIndex].overrideGallery);
  else if (!_.isUndefined(builder[props.optionsSource][optIndex].gallery) && builder[props.optionsSource][optIndex].gallery.length) gallery = JSON.parse(builder[props.optionsSource][optIndex].gallery);
  lightbox.open(description, gallery);
  e.preventDefault();
  return false;
}

function hasLightbox(opt) {
  if (!_.isUndefined(opt.overrideGallery) && JSON.parse(opt.overrideGallery) && JSON.parse(opt.overrideGallery).length) return true;
  if (!_.isUndefined(opt.gallery) && JSON.parse(opt.gallery) && JSON.parse(opt.gallery).length) return true;
  return false;
}

function isSelected(opt) {
  let compare = null;
  if (!_.isUndefined(props.scope) && props.scope.length) {
    if (props.scope == 'quote') compare = builder.quote[props.fieldName];
    else if (props.scope == 'section') compare = builder.currentSection[props.fieldName];
    else compare = builder.currentItem[props.scope][props.fieldName];
  } else {
    compare = builder.currentItem[props.fieldName];
  }
  if (builder.currentSectionConfig) {
    if (typeof builder.currentSectionConfig.configIds !== 'undefined' && builder.currentSectionConfig.configIds.includes(opt['id'])) return true;
  }
  if (opt['id'] == compare) return true;
  return false;
}

const optClass = computed(() => {
  let optClass = '';
  if (!_.isUndefined(props.displayType)) {
    let sep = '';
    for (let i = 0; i < props.displayType.length; i++) {
      optClass += sep + 'l_' + props.displayType[i];
      sep = ' ';
    }
  }
  return optClass;
})

const toggledMessage = computed(() => {
  let toggledMessage = '';

  let compare = null;
  if (!_.isUndefined(props.scope) && props.scope.length) {
    if (props.scope == 'quote') compare = builder.quote[props.fieldName];
    else if (props.scope == 'section') compare = builder.currentSection[props.fieldName];
    else compare = builder.currentItem[props.scope][props.fieldName];
  } else {
    compare = builder.currentItem[props.fieldName];
  }

  const selectedOption = builder[props.optionsSource].find(opt => opt.id === compare);
  if (selectedOption && typeof selectedOption.message !== 'undefined' && selectedOption.message && selectedOption.message.length) {
    toggledMessage = selectedOption.message;
  }

  return toggledMessage;
})
</script>
